import { SxProps, Theme } from '@mui/material/styles';

export const bar: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 0.5,
};

export const dropdownButton: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  height: 36,
  px: 1,
  borderRadius: 1,
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const dropdownButtonLabel = (isActive: boolean): SxProps<Theme> => ({
  typography: 'body2',
  fontWeight: 500,
  color: isActive ? 'primary.main' : 'text.primary',
});

export const dropdownButtonIcon = (isActive: boolean): SxProps<Theme> => ({
  fontSize: 20,
  color: isActive ? 'primary.main' : 'text.primary',
});

export const clearAllButton: SxProps<Theme> = {
  color: 'text.secondary',
  px: 1,
  minWidth: 'auto',
  '&:not(:disabled)': {
    color: 'text.primary',
  },
};

export const popoverPaper: SxProps<Theme> = {
  mt: 0.5,
  p: 1.5,
  bgcolor: 'background.paper',
  backgroundImage: 'none',
};

export const popoverContent: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: 1,
  minWidth: 220,
};

export const clearButton: SxProps<Theme> = {
  color: 'primary.main',
  px: '5px',
  py: '4px',
  minWidth: 'auto',
};

export const sliderBox: SxProps<Theme> = {
  width: '100%',
  px: 1,
  pt: 2,
};

export const sliderScale: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  mt: -0.5,
  color: 'text.secondary',
};

export const inputRow: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: 1,
  width: '100%',
};
